/**
 * Author:chenxing,
 * Create:2020-04-23
 */
import http from '@/http/index'

export const apiEngineeringCompany = {
  list: (params) => http.post('/teamInfo/listEngineeringCompany', params) // https://api.gcw.net:9999/search/keywords?words=gd&page=1&limit=10

  // searchKeywordsCount: (params) => http.get('/search/searchKeywordsCount', params) // ?words=乌鲁木齐 关键词分类数量统计 get请求
}
